<template>
  <div class="grid gap-8 p-10">
    <div
      class="grid bg-white border rounded-md px-6 py-4 leading-tight"
      v-if="currentUser"
    >
      <h2 class="text-4xl font-black text-gray-800">
        {{ `${currentUser.first_name} ${currentUser.last_name}` }}
      </h2>
      <p class="text-lg font-black mb-3 text-gray-800">
        {{ currentUser.email }}
      </p>
      <p class="mb-4 text-gray-800">
        your role is
        <strong class="capitalize">{{ currentUser.role.name }}</strong
        >, You can {{ roleMessage }}
      </p>
    </div>
    <div class="grid bg-indigo-500 rounded-md p-6 leading-tight">
      <h2 class="text-4xl font-black text-black">Adbox</h2>
      <p class="text-white text-lg font-black">Enjoy like the customer</p>
      <p class="mb-4 text-white">You can check how the customers see it</p>
      <a :href="libraryURL" target="_blank">
        <Button class="bg-white text-indigo-700" size="small">
          Go To Library
        </Button>
      </a>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import Button from "@/components/UI/Button";

export default {
  name: "Home",
  components: { Button },
  setup() {
    const store = useStore();

    const libraryURL = computed(() => process.env.VUE_APP_ADBOX_APP_FRONT_URL);
    const currentUser = computed(() => store.state.currentUser);

    const roleMessage = computed(() => {
      switch (currentUser.value.role.name) {
        case "admin":
          return "create and edit advertisements";
        case "super":
          return "do everything";
        default:
          return "... Wow! You shouldn't be here";
      }
    });

    return { libraryURL, currentUser, roleMessage };
  },
};
</script>
